import { AxiosError } from "axios";
import { api } from "constants/RotasAPI";
import { UserContext } from "context/UserContext";
import usePost from "hooks/usePost";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { ResponseEntity } from "types/dto/ResponseEntity";
import { ResponseError } from "types/dto/ResponseError";
import { TokenDTO } from "types/dto/TokenDTO";
import { RequestAuthenticate } from "types/request/RequestAuthenticate";

export const usePostAuthenticate = () => {
  const { loginContext } = useContext(UserContext);

  const onSuccess = (response: ResponseEntity<TokenDTO>) => {
    if (response?.data.token) {
      localStorage.setItem("jhi-authenticationToken", response.data.token);
      loginContext();
    }
    queryClient.invalidateQueries();
  };

  const onError = (error: AxiosError<ResponseError>) => {
    if (error?.response?.data?.validation[0]?.groupCode) {
      toast.error(error.response.data.validation[0].groupCode);
    } else {
      toast.error("Erro ao enviar e-mail.");
    }
  };

  return usePost<RequestAuthenticate>({
    url: api.login.postAuthenticate,
    onSuccess,
    onError,
  });
};
